<template>
  <div id="forgetPassword">
    <el-row
      type="flex"
      class="logoWrap"
      :class="`${$mq}Mode`"
    >
      <el-col
        class="logoCol"
        :span="responsiveCol"
      >
        <div
          class="logo"
          @click="$router.push({name: 'login'}).catch((err) => {})"
        >
          <img
            src="@/assets/logo/gcg_logo.png"
            alt="logo"
          />
        </div>
      </el-col>

      <el-col
        v-if="$mq !== 'mobile'"
        class="sloganCol"
        :span="responsiveCol"
      >
        <div class="slogan">
          <img
            src="@/assets/logo/gcg_slogan.png"
            alt="logo"
          />
        </div>
      </el-col>
    </el-row>

    <div class="wrapper">
      <el-card
        :style="{width: passwordWidth}"
        shadow="hover"
      >
        <div v-if="!done">
          <div class="title defaultCursor">
            {{ $t('account.forgetPw.title') }}
          </div>

          <div class="description defaultCursor">
            {{ $t('account.forgetPw.description') }}
          </div>

          <el-form
            ref="passwordForm"
            :model="passwordForm"
            :rules="rules"
            @keyup.enter="submit"
          >
            <el-form-item
              prop="email"
              :label="$t('account.emailAddress')"
              :error="error.email[0]"
            >
              <el-input
                v-model="passwordForm.email"
                :placeholder="$t('account.emailAddress')"
                @keydown.native.enter.prevent="submit"
              />
            </el-form-item>
          </el-form>

          <div class="actions">
            <el-button
              type="primary"
              round
              @click="submit"
            >
              {{ $t('common.submit') }}
            </el-button>
          </div>
        </div>
        <div v-else>
          <div class="title defaultCursor">
            {{ $t('account.forgetPw.result.title') }}
          </div>

          <div class="description defaultCursor">
            {{ $t('account.forgetPw.result.description') }}
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import DialogSetting from '@/mixins/dialog';

export default {
  mixins: [DialogSetting],

  data() {
    return {
      passwordForm: {
        email: '',
      },
      rules: {
        email: [
          { required: true, message: `${this.$t('common.rule.email.required')}`, trigger: 'blur' },
          { type: 'email', message: `${this.$t('common.rule.email.correct')}`, trigger: 'blur' },
        ],
      },
      error: {
        email: [],
      },
      done: false,
    };
  },

  computed: {
    responsiveCol() {
      let col = 12;
      if (this.$mq === 'mobile') {
        col = 24;
      }
      return col;
    },
  },

  methods: {
    async submit() {
      try {
        await this.$refs.passwordForm.validate();

        this.error.email = [];
        const response = await api.resetLocalUserPassword({
          email: this.passwordForm.email,
        });
        console.log(response);
        this.done = true;
      } catch (err) {
        console.log('error', err);
        if (err.response && err.response.data && err.response.data.email) {
          this.error.email = err.response.data.email;
        } else if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #forgetPassword {
    padding-bottom: 30px;

    .logoWrap {
      width: 100%;
      padding: 45px 5%;

      .logoCol {
        .logo {
          img {
            width: 110px;
          }
        }
      }

      .sloganCol {
        text-align: right;

        .slogan {
          img {
            width: 180px;
          }
        }
      }

      &.mobileMode {
        padding: 30px 0;

        .logoCol {
          text-align: center;

          .logo {
            img {
              width: 100px !important;
            }
          }
        }
      }

      &.tabletMode {
        padding: 40px 5%;

        .logoCol {
          .logo {
            img {
              width: 100px !important;
            }
          }
        }

        .sloganCol {
          .slogan {
            img {
              width: 170px !important;
            }
          }
        }
      }
    }

    .wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .el-card {
        width: 440px;
        border-radius: 4px;
        margin: 0 auto;

        .title {
          font-size: 24px;
          margin-bottom: 15px;
        }

        .description {
          margin-bottom: 15px;
        }

        .actions {
          text-align: center;
        }
      }
    }
  }
</style>

<style lang="scss">
#forgetPassword {
  .el-form {
    margin-bottom: 30px;

    .el-input__inner {
      border-radius: 0;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      padding: 0;
      font-size: 16px;
    }
  }
}
</style>
